import { Component, OnInit } from '@angular/core';
import { SCopyCaseEntryService } from '../pages/copy-case/copy-case-entry/s-copy-case-entry.service';

@Component({
  selector: 'app-print-case-annex-iii-report',
  templateUrl: './print-case-annex-iii-report.component.html',
  styleUrls: ['./print-case-annex-iii-report.component.scss']
})
export class PrintCaseAnnexIIIReportComponent implements OnInit {

  breadCrumbItems: Array<{}>;
  
  constructor(public objSCopyCaseEntryService: SCopyCaseEntryService) { }

  ngOnInit(): void {
    this.objSCopyCaseEntryService.getCopyCasesII()
  }
}
